export default __webpack_public_path__ + "44b6beedc7b7a865a59d8d280938e127.svg";